globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ComponentVideo = (function() {
    var defaults = {
        player     : $('#modal-video-player'),
        playVideo  : '.component-video-play',
        closeVideo : '.video-player-close',
        container  : '#video-iframe-container',
        iframes    : '.video-iframe-overlay'
    }

    function ComponentVideo($html, options) {
      this.config = $.extend({}, defaults, options);
      this.$html = $html;
      this.id = $html.data('id');
      this.externalUrl = $html.data('external-url');
      this.type = $html.data('type');
      this.initApi();
      this.events();
    }

    ComponentVideo.prototype = {
        initApi: function() {
          if(this.type) {
            if(this.type == "external_file") {
              this.api = new ComponentVideo.Apis["ExternalFile"](this.$html);
            } else {
              this.api = new ComponentVideo.Apis[utils.capitalize(this.type + 'Api')](this.$html);
            }
          }
        },
        events : function() {
            var me = this;
            this.$html.on('click', this.config.playVideo, function() {
                me.config.player.show();
                me.embed();
            });
            this.config.player.on('click', this.config.closeVideo, function() {
                me.close();
            });
            this.config.player.click(function(e) {
                if(e.target == me.config.player[0]) {
                    me.close();
                }
            });
        },
        embed : function() {
            var self = this,
                players = {
                  youtube       : '<iframe class="video-iframe-overlay" width="400" height="225" src="https://www.youtube.com/embed/' + this.id + '?enablejsapi=1&rel=0&autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>',
                  dailymotion   : '<div class="video-iframe-overlay" data-id="' + this.id + '" data-width="400" data-height="225" data-autoplay="1"></div>',
                  vimeo         : '<iframe class="video-iframe-overlay" width="400" height="225" src="https://player.vimeo.com/video/' + this.id + '?autoplay=1" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>',
                  external_file  : '<video class="video-iframe-overlay" width="400" height="225" autoplay="autoplay" src="' + this.externalUrl + '" style="width: 100%; height: 100%;" controls>'
                };

            var $player = $(players[this.type]);

            this.config.player.find(this.config.container).append($player);

            this.api.initPlayer($(this.config.iframes + ':not(.initialized)'));

            this._fluidPlayer();
        },
        close : function() {
            var me = this;
            this.config.player.fadeOut('fast', function() {
                $(me.config.iframes).remove();
            });
        },
        _fluidPlayer : function() {
            var $fluid   = $(this.config.container),
                $iframes = $(this.config.iframes);

            $iframes.each(function() {
                $(this).data('aspectRatio', this.height / this.width)
                       .removeAttr('height')
                       .removeAttr('width')
            });

            $(window).resize(function() {
              var newWidth = $fluid.width();
              $iframes.each(function()  {
                    var $iframe = $(this);
                    $iframe.width(newWidth)
                           .height(newWidth * $iframe.data('aspectRatio'));
                });
            }).resize();
        }
    }

    ComponentVideo.Apis = {
      YoutubeApi: (function() {
        YoutubeApi.API_URL = 'https://www.youtube.com/iframe_api';

        function YoutubeApi() {
          this.init();
        }

        YoutubeApi.initPlayers = function($els) {
          $els.each(function() {
            var $this = $(this);

            $this.addClass('initialized');

            var player = new YT.Player(this, {
              events: {
                onStateChange: function(e) {
                  if(e.data == 1) {
                    if($this.data('started')) {
                    } else {
                      $this.data('started', true);
                    }
                  } else if(e.data == 2) {
                  } else if(e.data == 0) {
                    $this.data('started', false);
                  }
                }
              }
            });
          });
        }

        YoutubeApi.prototype = {
          init: function() {
            utils.require([YoutubeApi.API_URL], function() {});
          },
          initPlayer: function($iframe) {
            YoutubeApi.initPlayers($iframe);
          }
        }

        return YoutubeApi;
      })(),

      ExternalFile: (function() {

        function ExternalFile($html) {
          this.$html = $html;
        }

        ExternalFile.initPlayers = function($els) {
        }

        ExternalFile.prototype = {
          init: function() {
            var self = this;
          },

          initPlayer: function($iframe) {
            ExternalFile.initPlayers($iframe);
          }
        }

        return ExternalFile;
      })()
    }

    return ComponentVideo;
})();

function onYouTubeIframeAPIReady() {
  appCustomerSpace.ComponentVideo.Apis.YoutubeApi.initPlayers($('.video-iframe'));
}
